import { subMonths } from 'date-fns';
import { create } from 'zustand';
import { LoginPeriod, UserActivityItemResponseDto, UserActivityType } from '@/features/superAdmin/features/dashboard/types/super-admin-dashboard-dto';

const TODAY = new Date();
const DEFAULT_PAGE_SIZE = 10;

type SuperAdminDashboardFilterType = {
    filter: {
        startDate?: Date | null;
        endDate?: Date | null;
        reportPeriod: LoginPeriod;
        take: number;
        skip?: number;
        orderBy?: Capitalize<keyof UserActivityItemResponseDto> | null;
        orderDirection: 'asc' | 'desc';
        activityType: UserActivityType | null;
        page: number;
        searchText: string;
    };
    setFilter: (filter: Partial<SuperAdminDashboardFilterType['filter']>) => void;
    resetFilter: () => void;
};

const defaultState: SuperAdminDashboardFilterType['filter'] = {
    startDate: subMonths(TODAY, 6),
    endDate: TODAY,
    reportPeriod: LoginPeriod.Monthly,
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
    orderBy: null,
    orderDirection: 'asc',
    activityType: null,
    page: 0,
    searchText: ''
};

export const useSuperAdminDashboardFilter = create<SuperAdminDashboardFilterType>((set) => ({
    filter: { ...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({
            filter: { ...defaultState },
        });
    },
}));
